import BaseView from './BaseView';

let view = null;

class Prompts extends BaseView {
	constructor(container) {
		super(container);
	}
	init() {
		const backgrounds = Array.from(this.container.querySelectorAll('[data-prompt-bg]'));
		const prompts = this.container.querySelectorAll('[data-prompt]');

		prompts.forEach((prompt) => {
			prompt.addEventListener('mouseenter', (e) => {
				const bg = backgrounds.find((bg) => bg.dataset.promptBg == e.target.dataset.prompt);

				if (!bg) {
					return;
				}

				bg.classList.add('is-active');
			});

			prompt.addEventListener('mouseleave', (e) => {
				const bg = backgrounds.find((bg) => bg.dataset.promptBg == e.target.dataset.prompt);

				if (!bg) {
					return;
				}

				bg.classList.remove('is-active');
			});
		});
	}
}

export default {
	namespace: 'template-prompts',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Prompts(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
